// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2JLMX","head":"Table_head__3xB1c","col":"Table_col__mMb-N"};